import { IModel, Model, ModelRecord } from './Model';
import { defaultTo } from 'lodash';
import { DateTime } from 'luxon';
import { DateTimeUtils } from '@common/utils/datetimeUtils';

export interface IClinicListingModel extends IModel {
  clinicId: number;
  storeId: number;
  storeCode: string;
  storeAddress: string;
  scheduledStartDate: string | undefined;
  scheduledEndDate: string;
  isClosed: boolean;
  isPendingClose: boolean;
  isCancelled: boolean;
  isPublished: boolean;
  storeParent: string;
  storeStateAbbrev: string;
}

export class ClinicListingModel
  extends Model
  implements ModelRecord<IClinicListingModel>
{
  clinicId: number;
  storeId: number;
  storeCode: string;
  storeAddress: string;
  scheduledStartDate: DateTime | undefined;
  scheduledEndDate: DateTime | undefined;
  startTime: string;
  endTime: string;
  isClosed: boolean;
  isPendingClose: boolean;
  isCancelled: boolean;
  isPublished: boolean;
  storeParent: string;
  storeStateAbbrev: string;

  constructor(params: Partial<IClinicListingModel>) {
    super(params);
    this.clinicId = defaultTo(params.clinicId, 0);
    this.storeId = defaultTo(params.storeId, 0);
    this.storeCode = defaultTo(params.storeCode, '');
    this.storeAddress = defaultTo(params.storeAddress, '');
    this.scheduledStartDate = DateTime.fromISO(
      defaultTo(params.scheduledStartDate, '2000-01-01'),
      { zone: 'utc' },
    );
    this.scheduledEndDate = DateTime.fromISO(
      defaultTo(params.scheduledEndDate, '2000-01-01'),
      { zone: 'utc' },
    );
    this.startTime = DateTimeUtils.getTimehour12(this.scheduledStartDate);
    this.endTime = DateTimeUtils.getTimehour12(this.scheduledEndDate);
    this.isClosed = defaultTo(params.isClosed, false);
    this.isPendingClose = defaultTo(params.isPendingClose, false);
    this.isCancelled = defaultTo(params.isCancelled, false);
    this.isPublished = defaultTo(params.isPublished, false);
    this.storeParent = defaultTo(params.storeParent, '');
    this.storeStateAbbrev = defaultTo(params.storeStateAbbrev, '');
  }
}
